// Path scheme for the public, shareable sport club home page. A single place
// builds and parses `/club/:token` so the share/copy link and the client-side
// route resolver (`main.tsx`) always agree. The token is the company's opaque
// home token (never the integer id). Kept framework-free so it can be
// unit-tested in isolation, mirroring `sharePath.ts` and `profileSharePath.ts`.

const PREFIX = '/club/';

/** In-app path for a club's public home page, e.g. "/club/Club_abc". */
export function publicClubPath(homeToken: string): string {
  return `${PREFIX}${encodeURIComponent(homeToken)}`;
}

/**
 * Extract the club home token from a public-club pathname, or null when the path
 * is not a public-club route. Accepts an optional trailing slash and rejects
 * extra path segments so only `/club/<token>` resolves.
 */
export function parsePublicClubPath(pathname: string): string | null {
  if (!pathname.startsWith(PREFIX)) return null;
  const rest = pathname.slice(PREFIX.length).replace(/\/+$/, '');
  if (rest.length === 0 || rest.includes('/')) return null;
  try {
    const token = decodeURIComponent(rest);
    return token.length > 0 ? token : null;
  } catch {
    return null; // malformed percent-encoding
  }
}

/** Absolute share URL (origin + path) used by the copy button / QR code. */
export function publicClubUrl(homeToken: string, origin: string): string {
  return `${origin}${publicClubPath(homeToken)}`;
}
